
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'ReadMore'
})
export default class ReadMore extends Vue {
  @Prop({ type: Number, default: 122 }) readonly length: number

  readMoreActivated = false

  get longText() {
    return this.$slots.default?.[0]?.text
  }

  get readMoreNeeded() {
    return this.longText.length > this.length
  }

  handleButtonClick(state: boolean) {
    this.readMoreActivated = state
    this.$emit('toggle', state)
  }
}
